import { AmountCell, DateCell } from '@omnipresentgroup/design-system';
import type { SalaryHistoryEntry } from '@omnipresentgroup/types';
import {
  type CellContext,
  type ColumnDef,
  createColumnHelper,
} from '@tanstack/react-table';

import { ColumnHeaders } from './headers';

const columnHelper = createColumnHelper<SalaryHistoryEntry>();

const defaultRenderer = (info: CellContext<SalaryHistoryEntry, string>) =>
  info.getValue();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Columns: ColumnDef<SalaryHistoryEntry, any>[] = [
  columnHelper.accessor('employeeId', {
    header: ColumnHeaders.employeeId,
    cell: defaultRenderer,
    size: 200,
  }),
  columnHelper.accessor('employeeName', {
    header: ColumnHeaders.employeeName,
    cell: defaultRenderer,
    size: 200,
    enableGlobalFilter: true,
  }),
  columnHelper.accessor('reason', {
    header: 'Reason',
    cell: defaultRenderer,
    size: 100,
  }),
  columnHelper.accessor('previousSalary', {
    header: ColumnHeaders.oldAnnualGrossAmount,
    cell: (info) => (
      <AmountCell
        amount={info.getValue()?.amount}
        currency={info.getValue()?.currency}
      />
    ),
    size: 100,
  }),
  columnHelper.accessor('newSalary', {
    header: ColumnHeaders.newAnnualGrossAmount,
    cell: (info) => (
      <AmountCell
        amount={info.getValue()?.amount}
        currency={info.getValue()?.currency}
      />
    ),
    size: 100,
  }),
  columnHelper.accessor('effectiveDate', {
    header: ColumnHeaders.effectiveDate,
    cell: (info) => <DateCell value={info.getValue()} />,
    sortingFn: 'datetime',
    size: 90,
  }),
  columnHelper.accessor('requestedAt', {
    header: ColumnHeaders.requestedAt,
    cell: (info) => <DateCell value={info.getValue()} />,
    sortingFn: 'datetime',
    size: 90,
  }),
];
